import { forEach, map, merge, sortBy } from 'lodash';
import validator from './validator';

const _configs:any = {};

class ConfigHandler {
	// target is a config object
	get (target, name) {
		if (name === 'withVariant') {
			return variant => {
				return factory(variant); // eslint-disable-line no-use-before-define
			};
		}
		else if (name === 'withDefault') {
			return () => {
				return factory('_'); // eslint-disable-line no-use-before-define
			};
		}
		else if (name === 'getString') {
			return (val, context) => {
				return getString(val, context, target); // eslint-disable-line no-use-before-define
			};
		}
		else if (name === 'variants') {
			return sortBy(_configs, ['priority', 'companyName']);
		}

		return Reflect.get(target, name);
	}
}

function factory (variant) {
	const config = _configs[variant] || _configs._;

	return new Proxy(config, new ConfigHandler());
}

function getString (val, context, config) {
	const strings = config.localization.strings;
	const string = strings[val];

	// return a simple string if it exists
	if (typeof string === 'string') {
		return string;
	}

	// check for a matching context string
	if (typeof string !== 'undefined' && typeof string[context] === 'string') {
		return string[context];
	}

	// fall back to returning the passed val
	return val;
}

export default (config) => {
	const variants = config.variants;

	delete config.variants;
	forEach(config.search.params, (v, k) => {
		config.search.params[k] = map(v, param => {
			let searchTextTest;

			if (param.searchTextTest) {
				if (param.searchTextTest.indexOf('validator.') === 0) {
					searchTextTest = { test: val => validator[param.searchTextTest.split('.')[1]](val) };
				}
				else {
					searchTextTest = new RegExp(param.searchTextTest, 'i');
				}
			}

			return {
				key: param.key,
				name: param.name || getString.call(undefined, param.nameKey[0], param.nameKey[1], config),
				searchTextTest
			};
		});
	});

	_configs._ = config;

	forEach(variants, (v, k) => {
		_configs[k] = merge({ priority: 1, variant: k }, config, v);
	});

	_configs._.priority = 0;
	_configs._.variant = _configs._.companyKey;

	return factory('_');
};
